<template>
<md-card>
    <header-form title="DADOS DO USUÁRIOS" :rota="{name: 'usuarioRead'}" tooltip="Lista de Usuários" />

    <md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-size-10 md-xsmall-size-100 uppercase">
                <h4><strong class="text-secondary">ID: </strong>{{ usuario.id }}</h4>
            </div>

            <div class="md-layout-item md-size-55 md-xsmall-size-100 uppercase">
                <h4><strong class="text-secondary">NOME: </strong>{{ usuario.nome }}</h4>
            </div>

            <div class="md-layout-item md-size-35 md-xsmall-size-100 uppercase">
                <h4><strong class="text-secondary">APELIDO: </strong>{{ usuario.apelido }}</h4>
            </div>
        </div>

        <div class="md-layout formView">
            <div class="md-layout-item md-size-40 md-xsmall-size-100 uppercase">
                <h4><strong class="text-secondary">USUÁRIO: </strong>{{ usuario.usuario }}</h4>
            </div>

            <div class="md-layout-item md-size-30 md-xsmall-size-100 uppercase">
                <h4><strong class="text-secondary">SITUAÇÃO: </strong>{{ usuario.situacao }}</h4>
            </div>

            <div class="md-layout-item md-size-30 md-xsmall-size-100 uppercase">
                <h4><strong class="text-secondary">Data de cadastro: </strong>{{ usuario.data }}</h4>
            </div>
        </div>
    </md-card-content>

</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            usuario: {}
        }
    },

    created() {
        this.getUsuario()
    },

    mixins: [Notify],

    methods: {

        getUsuario() {
            this.$http.get(this.$urlAPI + 'usuarios/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.dados[0];
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    }
};
</script>

